// This file stores constants used throughout the app
// Like API URLs, colors, and other values that don't change

/**
 * What this file does:
 *  Stores Plan Participant colors so they're consistent everywhere
 *  Stores API URL (changes based on development vs production)
 *  Stores constants like lead stages
 *  Helper function to color-code scores
 */




// Plan Participant brand colors
export const COLORS = {
  primary: '#1E3A8A',      // Plan Participant blue
  secondary: '#F97316',    // Plan Participant orange
  success: '#10B981',      // Green for positive
  warning: '#F59E0B',      // Yellow for caution
  danger: '#EF4444',       // Red for alerts
  gray: {
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827',
  }
};

// API base URL
// In development, this is localhost
// In production, this is your Netlify URL
export const API_BASE_URL = process.env.NODE_ENV === 'development'
  ? 'http://localhost:8888/.netlify/functions'
  : '/.netlify/functions';

// Lead stage options
export const LEAD_STAGES = {
  COLD: 'cold',
  ENGAGED: 'engaged',
  QUALIFIED: 'qualified',
  ASSIGNED: 'assigned',
};

// Score color ranges
// Used to color-code lead scores
export const getScoreColor = (score) => {
  if (score >= 80) return COLORS.success;      // Green for high scores
  if (score >= 60) return COLORS.warning;      // Yellow for medium scores
  return COLORS.danger;                        // Red for low scores
};

// Format engagement types for display
export const ENGAGEMENT_TYPES = {
  email_opened: 'Email Opened',
  link_clicked: 'Link Clicked',
  email_replied: 'Email Replied',
  meeting_booked: 'Meeting Booked',
  added_to_campaign: 'Added to Campaign',
};

// Activity level categorization
export const ACTIVITY_LEVELS = {
  REPLIED: 'replied',
  SUBMITTED: 'submitted',
  CLICKED: 'clicked',
  OPENED: 'opened',
  INACTIVE: 'inactive'
};

// Get activity level for a lead based on most recent engagement
export const getActivityLevel = (lead) => {
  if (!lead.engagement || lead.engagement.length === 0) {
    return ACTIVITY_LEVELS.INACTIVE;
  }
  
  // Sort events by date (newest first) and check the most recent activity
  const sortedEvents = [...lead.engagement].sort((a, b) => new Date(b.date) - new Date(a.date));
  const mostRecent = sortedEvents[0];
  
  // Check the most recent event type and map to activity level
  // Include both Instantly and HubSpot event types
  if (mostRecent.type === 'email_reply' || 
      mostRecent.type === 'email_replied' || 
      mostRecent.type === 'hubspot_email_reply') {
    return ACTIVITY_LEVELS.REPLIED;
  }
  
  if (mostRecent.type === 'form_submit' || mostRecent.type === 'form_submitted') {
    return ACTIVITY_LEVELS.SUBMITTED;
  }
  
  if (mostRecent.type === 'link_click' || 
      mostRecent.type === 'link_clicked' || 
      mostRecent.type === 'hubspot_email_click') {
    return ACTIVITY_LEVELS.CLICKED;
  }
  
  if (mostRecent.type === 'email_open' || 
      mostRecent.type === 'email_opened' || 
      mostRecent.type === 'hubspot_email_open') {
    return ACTIVITY_LEVELS.OPENED;
  }
  
  // For any other event types, return inactive
  return ACTIVITY_LEVELS.INACTIVE;
};